var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-prices-service-calendar d-flex flex-column ga-4",
      attrs: { "data-qa": "lpu_services_service_price_schedule" },
    },
    [
      _c(_setup.DayTabs, {
        attrs: {
          "data-qa": "lpu_services_service_price_schedule_days",
          items: _vm.dayItems,
          "active-date": _vm.activeDate,
        },
        on: {
          select: function ($event) {
            return _setup.emit("select-day", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.activeDaySlots.length
        ? _c(_setup.SlotButtons, {
            attrs: {
              "data-qa": "lpu_services_service_price_schedule_slots",
              "slot-qa": "lpu_services_service_price_schedule_slot",
              "expand-qa": "lpu_services_service_price_schedule_slots_expand",
              slots: _vm.activeDaySlots,
            },
            on: { click: (_nativeEvent, time) => _setup.emit("slot", time) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }